import store from "../../store";
var _ = require("lodash/core");
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export const Mixins = {
  methods: {
    fetchPrimaryArticle(slug) {
      return store.getters.getArticle(slug);
    },

    fetchAlternativeArticles(articles) {
      let _rtn = [];
      _.forEach(articles, (article) => {
        _rtn.push(store.getters.getArticle(article.slug));
      });
      return _rtn;
    },

    hasRead(slug) {
      let article = store.getters.getArticle(slug);
      if (article && article.read_status) {
        return this.readStatus(article.read_status.code);
      }
      return false;
    },

    readStatus(code) {
      if (code === "unread" || code === "clicked" || code === "preview") {
        return false;
      }
      return code;
    },

    publisherIcon() {
      return (this.fetchPrimaryArticle(this.slug).publisher || {}).icon;
    },

    timeAgo(date) {
      return dayjs().to(dayjs(date));
    },

    didSelectArticle(article, story) {
      this.EventBus.$emit("didSelectArticle", {
        event: event,
        src: this,
        article: article,
        story: story,
      });
    },

    didSelectStory(slug) {
      // console.log("didSelectStory: ", slug);
      this.$router.push(`/story/${slug}`); // .catch(() => {});

      // need to put the modal wrapper on the topic page...
      // this.EventBus.$emit("modal:full-story", slug);
    },

    didSelectPreviewArticle(article, story) {
      if (story && story !== "-") {
        let slug = story && story.slug ? story.slug : "-";
        this.$router.push(`/story/${slug}`); // .catch(() => {});
        // this.EventBus.$emit("modal:full-story", slug);
      } else {
        this.EventBus.$emit("didSelectArticle", {
          src: this,
          article: article,
          story: "-",
        });
      }
    },
  },
};
